const htmlToImage = require("html-to-image");
const { isEmpty } = require("./default_parts/functions/miscellaneous");

window.elocaSincronizarBotoesOrcamentoPorProdutos = function () {
    const $botoes = $(".js-racerregar-modelo, .js-abrir-enviar-orcamento-email");
    if (!$botoes.length) {
        return;
    }
    const temProdutos = $(".js-tabela-produtos tbody tr").length > 0;
    $botoes.toggleClass("d-none", !temProdutos);
};

Eloca.behaviors.oportunidadesEnviarEmailOrcamento = function (context) {
    if (window.elocaEnviarOrcamentoEmailBound) {
        return;
    }
    window.elocaEnviarOrcamentoEmailBound = true;

    const $root = $(document);
    let previewRequestId = 0;
    let isEnviandoOrcamentoEmail = false;
    let cachedPdfAttachment = {
        fileUrl: "",
        fileName: "",
        modeloId: null,
        file: null,
    };

    function getModal() {
        return $("#modalEnviarOrcamentoEmail").first();
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function validarEmailsFormulario() {
        const toEmail = (
            $("#orcamentoEmailDestinatario", context).val() || ""
        ).trim();
        if (!toEmail) {
            showToastDanger(context, "O destinatário é obrigatório.");
            return false;
        }
        if (!isValidEmail(toEmail)) {
            showToastDanger(context, "Informe um e-mail de destinatário válido.");
            return false;
        }

        const ccEmails = ($("#orcamentoEmailCcEmails", context).val() || "").trim();
        if (ccEmails) {
            const emails = ccEmails
                .split(",")
                .map(function (item) {
                    return item.trim();
                })
                .filter(Boolean);
            for (const email of emails) {
                if (!isValidEmail(email)) {
                    showToastDanger(
                        context,
                        "O campo Cc deve conter e-mails válidos, separados por vírgula."
                    );
                    return false;
                }
            }
        }

        return true;
    }

    function validarCamposCustomizadosImpressao() {
        const camposCustomizados = document.querySelectorAll(
            ".js-campo-customizado-valor"
        );
        const configBloqueio = $("#block_orcamento_campos_customizados").val();
        if (camposCustomizados.length > 0) {
            for (const campo of camposCustomizados) {
                const obrigaImp = campo.getAttribute("data-impressao");
                const obriga = campo.getAttribute("data-obrigatorio");
                if (
                    (obrigaImp == 1 && isEmpty(campo.value)) ||
                    (configBloqueio == 1 &&
                        isEmpty(campo.value) &&
                        obriga > 0)
                ) {
                    showToastDanger(
                        context,
                        "Favor preencha os campos customizados obrigatorios."
                    );
                    $("#campos-tab").trigger("click");
                    return false;
                }
            }
        }
        return true;
    }

    function alternarPreviewOrcamentoEmail(tipo) {
        const $modal = getModal();
        if (!$modal.length) {
            return;
        }

        const $loading = $modal.find("#previewOrcamentoEmailLoading");
        const $html = $modal.find("#previewOrcamentoEmailHtml");
        const $iframe = $modal.find("#iframePreviewOrcamentoEmail");
        const $btn = $modal.find(".js-enviar-orcamento-email");

        $loading.hide();
        $html.hide().removeClass("d-none");
        $iframe.hide().removeClass("d-none");
        $btn.prop("disabled", true);

        if (tipo === "loading") {
            $loading.show();
        } else if (tipo === "html") {
            $html.css({ display: "block", position: "relative", zIndex: 1 }).show();
            $btn.prop("disabled", false);
        } else if (tipo === "pdf") {
            $iframe.css({ display: "block", position: "relative", zIndex: 1 }).show();
            $btn.prop("disabled", false);
        }
    }

    function resetPreviewWrapper() {
        const $modal = getModal();
        if (!$modal.length) {
            return;
        }

        const $wrapper = $modal.find("#previewOrcamentoEmailWrapper");
        $wrapper.attr("data-pdf-filename", "");
        $wrapper.attr("data-pdf-url", "");
        cachedPdfAttachment = {
            fileUrl: "",
            fileName: "",
            modeloId: null,
            file: null,
        };
        $modal.find("#previewOrcamentoEmailHtml").empty();
        $modal.find("#iframePreviewOrcamentoEmail").attr("src", "");
        alternarPreviewOrcamentoEmail("loading");
    }

    function parseAssinaturaEmail($modal) {
        const raw = $modal.attr("data-assinatura-email");
        if (!raw) {
            return "";
        }

        try {
            return JSON.parse(raw) || "";
        } catch (error) {
            return raw;
        }
    }

    function getDefaultOrcamentoEmailMessageBody($modal) {
        const assinatura = parseAssinaturaEmail($modal).trim();
        if (!assinatura) {
            return "";
        }

        return "<p><br></p><p><br></p>" + assinatura;
    }

    function getOrcamentoEmailMessageBody() {
        const $textarea = $("#orcamentoEmailMessageBody", context);
        const editor = $textarea.data("ckeditorInstance");

        if (editor && typeof editor.getData === "function") {
            return (editor.getData() || "").trim();
        }

        return ($textarea.val() || "").trim();
    }

    function setOrcamentoEmailMessageBody($modal, messageBody) {
        const $textarea = $modal.find("#orcamentoEmailMessageBody");
        const editor = $textarea.data("ckeditorInstance");

        if (editor && typeof editor.setData === "function") {
            editor.setData(messageBody || "");
            return;
        }

        $textarea.val(messageBody || "");
    }

    function isOrcamentoEmailMessageBodyEmpty(messageBody) {
        if (!messageBody) {
            return true;
        }

        const text = $("<div>").html(messageBody).text().replace(/\u00a0/g, " ").trim();

        return text === "";
    }

    function clearOrcamentoEmailMessageBody($modal) {
        const $textarea = $modal.find("#orcamentoEmailMessageBody");
        const editor = $textarea.data("ckeditorInstance");

        if (editor && typeof editor.setData === "function") {
            editor.setData("");
            return;
        }

        $textarea.val("");
    }

    function resetModalState() {
        const $modal = getModal();
        if (!$modal.length) {
            return;
        }

        $modal.find("#selectModeloOrcamentoEmail").val("padrao");
        $modal.find("#orcamentoEmailDestinatario").val(
            $modal.attr("data-email-cliente") || ""
        );
        $modal.find("#orcamentoEmailCcEmails").val("");

        setOrcamentoEmailMessageBody(
            $modal,
            getDefaultOrcamentoEmailMessageBody($modal)
        );
        const $emailAccountSelect = $modal.find("#orcamentoEmailAccount");
        if ($emailAccountSelect.length) {
            $emailAccountSelect.prop("selectedIndex", 0);
        }

        resetPreviewWrapper();
    }

    function renderModeloPadraoHtml(html) {
        const $modal = getModal();
        if (!$modal.length) {
            return;
        }

        $modal.find("#previewOrcamentoEmailHtml").html(html || "");
        alternarPreviewOrcamentoEmail("html");
    }

    function loadModeloPadrao(skipReset) {
        const $modal = getModal();
        if (!$modal.length) {
            return;
        }

        const requestId = ++previewRequestId;
        if (!skipReset) {
            resetPreviewWrapper();
        }
        const url = $modal.attr("data-url-modelo-padrao");

        $.ajax({
            url: url,
            type: "GET",
            success: function (res) {
                if (requestId !== previewRequestId) {
                    return;
                }

                if (res && typeof res === "object" && res.url) {
                    $.ajax({
                        url: res.url,
                        type: "GET",
                        dataType: "html",
                        success: function (html) {
                            if (requestId !== previewRequestId) {
                                return;
                            }
                            renderModeloPadraoHtml(html);
                        },
                        error: function () {
                            if (requestId !== previewRequestId) {
                                return;
                            }
                            alternarPreviewOrcamentoEmail();
                            showToastDanger(
                                context,
                                "Não foi possível carregar o modelo padrão."
                            );
                        },
                    });
                    return;
                }

                renderModeloPadraoHtml(
                    typeof res === "string" ? res : ""
                );
            },
            error: function (xhr) {
                if (requestId !== previewRequestId) {
                    return;
                }
                alternarPreviewOrcamentoEmail();
                showToastDanger(
                    context,
                    xhr.responseJSON?.message ??
                        "Não foi possível carregar o modelo padrão."
                );
            },
        });
    }

    function fetchPdfFileFromUrl(fileUrl, fileName) {
        return fetch(fileUrl)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Não foi possível obter o arquivo PDF.");
                }
                return response.blob();
            })
            .then(function (blob) {
                const file = new File([blob], fileName, {
                    type: "application/pdf",
                });

                if (!file.size) {
                    throw new Error("O anexo PDF gerado está vazio.");
                }

                return file;
            });
    }

    function loadModeloPdf(modeloId) {
        const $modal = getModal();
        if (!$modal.length) {
            return;
        }

        const requestId = ++previewRequestId;
        resetPreviewWrapper();
        const baseUrl = $modal.attr("data-url-gerar-documento");

        $.ajax({
            url: siteUrl(baseUrl + "/" + modeloId),
            type: "GET",
            dataType: "json",
            headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            success: function (res) {
                if (requestId !== previewRequestId) {
                    return;
                }
                if (!res.success) {
                    alternarPreviewOrcamentoEmail();
                    showToastDanger(
                        context,
                        res.message || "Falha ao gerar o arquivo."
                    );
                    return;
                }
                const fileUrl = (res.file_url || "").trim();
                if (!fileUrl) {
                    alternarPreviewOrcamentoEmail();
                    showToastDanger(
                        context,
                        "Arquivo de orçamento vazio ou inválido."
                    );
                    return;
                }

                const fileName = res.filename || "orcamento.pdf";
                const $wrapper = $modal.find("#previewOrcamentoEmailWrapper");
                $wrapper.attr("data-pdf-filename", fileName);
                $wrapper.attr("data-pdf-url", fileUrl);
                cachedPdfAttachment = {
                    fileUrl: fileUrl,
                    fileName: fileName,
                    modeloId: String(modeloId),
                    file: null,
                };

                $modal.find("#iframePreviewOrcamentoEmail").attr("src", fileUrl);
                alternarPreviewOrcamentoEmail("pdf");

                fetchPdfFileFromUrl(fileUrl, fileName)
                    .then(function (file) {
                        if (
                            cachedPdfAttachment.modeloId === String(modeloId) &&
                            cachedPdfAttachment.fileUrl === fileUrl
                        ) {
                            cachedPdfAttachment.file = file;
                        }
                    })
                    .catch(function () {
                        // Preview via iframe segue disponível; envio tenta novamente.
                    });
            },
            error: function (xhr) {
                if (requestId !== previewRequestId) {
                    return;
                }
                alternarPreviewOrcamentoEmail();
                showToastDanger(
                    context,
                    xhr.responseJSON?.message ??
                        "Não foi possível gerar o arquivo de orçamento."
                );
            },
        });
    }

    function loadPreviewForSelectedModel() {
        const modelo = $("#selectModeloOrcamentoEmail", context).val();
        if (modelo === "padrao") {
            loadModeloPadrao();
        } else {
            loadModeloPdf(modelo);
        }
    }

    function dataUrlToPngFile(dataUrl, fileName) {
        const sliceSize = 1024;
        let base64 = dataUrl.replace(/^data:image\/png;base64,/, "");
        const byteCharacters = window.atob(base64);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            const begin = sliceIndex * sliceSize;
            const end = Math.min(begin + sliceSize, bytesLength);
            const bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }

        const blob = new Blob(byteArrays, { type: "image/png" });

        return new File([blob], fileName, { type: "image/png" });
    }

    function waitForImages(node) {
        const images = node.querySelectorAll("img");
        if (!images.length) {
            return Promise.resolve();
        }

        return Promise.all(
            Array.from(images).map(function (img) {
                if (img.complete && img.naturalWidth > 0) {
                    return Promise.resolve();
                }

                return new Promise(function (resolve) {
                    img.addEventListener("load", resolve, { once: true });
                    img.addEventListener("error", resolve, { once: true });
                });
            })
        );
    }

    function captureModeloPadraoPng(node) {
        const filter = function (element) {
            const excludedIds = [
                "previewOrcamentoEmailLoading",
                "iframePreviewOrcamentoEmail",
            ];
            if (excludedIds.includes(element.id)) {
                return false;
            }

            return !element.classList?.contains("loading-circle");
        };

        return waitForImages(node).then(function () {
            return htmlToImage.toPng(node, {
                filter: filter,
                skipFonts: true,
                cacheBust: true,
                pixelRatio: 1,
            });
        });
    }

    function fetchModeloPdfAttachment(modeloId) {
        const $modal = getModal();
        const baseUrl = $modal.attr("data-url-gerar-documento");
        const oportunidadeId = $modal.attr("data-oportunidade-id");

        return $.ajax({
            url: siteUrl(baseUrl + "/" + modeloId),
            type: "GET",
            dataType: "json",
            headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        }).then(function (res) {
            if (!res.success) {
                throw new Error(res.message || "Falha ao gerar o arquivo.");
            }

            const fileUrl = String(res.file_url || "").trim();
            if (!fileUrl) {
                throw new Error("Arquivo de orçamento vazio ou inválido.");
            }

            const fileName =
                (res.filename || "").trim() ||
                "orcamento-" + oportunidadeId + ".pdf";

            const $wrapper = $modal.find("#previewOrcamentoEmailWrapper");
            $wrapper.attr("data-pdf-filename", fileName);
            $wrapper.attr("data-pdf-url", fileUrl);
            cachedPdfAttachment = {
                fileUrl: fileUrl,
                fileName: fileName,
                modeloId: String(modeloId),
                file: null,
            };

            return fetchPdfFileFromUrl(fileUrl, fileName).then(function (file) {
                cachedPdfAttachment.file = file;
                return file;
            });
        });
    }

    function buildAttachmentFile() {
        const $modal = getModal();
        const modelo = $("#selectModeloOrcamentoEmail", context).val();
        const oportunidadeId = $modal.attr("data-oportunidade-id");

        if (modelo === "padrao") {
            const node = $modal.find("#previewOrcamentoEmailHtml")[0];
            if (!node || !node.innerHTML.trim()) {
                return Promise.reject(
                    new Error("Pré-visualização do orçamento não carregada.")
                );
            }

            return captureModeloPadraoPng(node).then(function (dataUrl) {
                if (!dataUrl || dataUrl.length < 100) {
                    throw new Error(
                        "Não foi possível gerar a imagem do orçamento."
                    );
                }

                const file = dataUrlToPngFile(
                    dataUrl,
                    "orcamento-" + oportunidadeId + ".png"
                );

                if (!file.size || file.size < 500) {
                    throw new Error(
                        "A imagem do orçamento gerada está vazia. Recarregue o preview e tente novamente."
                    );
                }

                return file;
            });
        }

        const $wrapper = $modal.find("#previewOrcamentoEmailWrapper");
        const fileName =
            (cachedPdfAttachment.fileName || "").trim() ||
            ($wrapper.attr("data-pdf-filename") || "").trim() ||
            "orcamento-" + oportunidadeId + ".pdf";
        const cachedModeloId = cachedPdfAttachment.modeloId;

        if (
            cachedModeloId === String(modelo) &&
            cachedPdfAttachment.file &&
            cachedPdfAttachment.file.size
        ) {
            return Promise.resolve(cachedPdfAttachment.file);
        }

        const fileUrl = (
            cachedPdfAttachment.fileUrl ||
            $wrapper.attr("data-pdf-url") ||
            ""
        ).trim();

        if (fileUrl && cachedModeloId === String(modelo)) {
            return fetchPdfFileFromUrl(fileUrl, fileName).then(function (file) {
                cachedPdfAttachment.file = file;
                return file;
            });
        }

        return fetchModeloPdfAttachment(modelo);
    }

    $root.on("click.elocaEnviarOrcamentoEmail", ".js-abrir-enviar-orcamento-email", function (e) {
        if (!validarCamposCustomizadosImpressao()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
    });

    $root
        .off("show.bs.modal.elocaEnviarOrcamentoEmail", "#modalEnviarOrcamentoEmail")
        .on("show.bs.modal.elocaEnviarOrcamentoEmail", "#modalEnviarOrcamentoEmail", function () {
            resetModalState();
            loadModeloPadrao(true);
        });

    $root
        .off("hidden.bs.modal.elocaEnviarOrcamentoEmail", "#modalEnviarOrcamentoEmail")
        .on("hidden.bs.modal.elocaEnviarOrcamentoEmail", "#modalEnviarOrcamentoEmail", function () {
            previewRequestId++;
            resetModalState();
        });

    $root
        .off("change.elocaEnviarOrcamentoEmail", "#selectModeloOrcamentoEmail")
        .on("change.elocaEnviarOrcamentoEmail", "#selectModeloOrcamentoEmail", function () {
            loadPreviewForSelectedModel();
        });

    $root
        .off("click.elocaEnviarOrcamentoEmail", ".js-enviar-orcamento-email")
        .on("click.elocaEnviarOrcamentoEmail", ".js-enviar-orcamento-email", function () {
            if (isEnviandoOrcamentoEmail) {
                return;
            }

            const messageBody = getOrcamentoEmailMessageBody();
            if (isOrcamentoEmailMessageBodyEmpty(messageBody)) {
                showToastDanger(context, "O corpo do email é obrigatório.");
                return;
            }

            if (!validarEmailsFormulario()) {
                return;
            }

            const $modal = getModal();
            if ($modal.find(".js-enviar-orcamento-email").prop("disabled")) {
                return;
            }

            const oportunidadeId = $modal.attr("data-oportunidade-id");
            const toEmail = (
                $("#orcamentoEmailDestinatario", context).val() || ""
            ).trim();
            const ccEmails = ($("#orcamentoEmailCcEmails", context).val() || "").trim();
            isEnviandoOrcamentoEmail = true;
            const $btnEnviar = $modal.find(".js-enviar-orcamento-email");
            $btnEnviar.prop("disabled", true);
            $("#overlayer-loading").addClass("show-overlayer");

            buildAttachmentFile()
                .then(function (attachmentFile) {
                    if (!attachmentFile || !attachmentFile.size) {
                        throw new Error("O anexo do orçamento está vazio.");
                    }

                    const formData = new FormData();
                    formData.append("messageBody", messageBody);
                    formData.append("toEmail", toEmail);
                    formData.append("ccEmails", ccEmails);
                    const $emailAccountSelect = $modal.find("#orcamentoEmailAccount");
                    if ($emailAccountSelect.length) {
                        formData.append("emailAccount", $emailAccountSelect.val());
                    }
                    formData.append("files[]", attachmentFile);

                    return $.ajax({
                        url: $modal.attr("data-url-enviar") || siteUrl(
                            "/painel/oportunidades/email-send-orcamento/" + oportunidadeId
                        ),
                        type: "POST",
                        data: formData,
                        processData: false,
                        contentType: false,
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            ),
                        },
                    });
                })
                .then(function (res) {
                    showToastSuccess(
                        context,
                        res.message || "E-mail enviado com sucesso!"
                    );
                })
                .catch(function (err) {
                    let errorMessage = "Erro ao enviar email";
                    if (err.responseJSON?.message) {
                        errorMessage = err.responseJSON.message;
                    } else if (err.message) {
                        errorMessage = err.message;
                    }
                    if (err.responseJSON?.errors) {
                        Object.values(err.responseJSON.errors).forEach(function (
                            item
                        ) {
                            errorMessage = errorMessage.concat("</br>", item);
                        });
                    }
                    showToastDanger(context, errorMessage);
                })
                .finally(function () {
                    isEnviandoOrcamentoEmail = false;
                    $("#overlayer-loading").removeClass("show-overlayer");
                    if (
                        $modal.find("#previewOrcamentoEmailHtml").is(":visible") ||
                        $modal.find("#iframePreviewOrcamentoEmail").is(":visible")
                    ) {
                        $btnEnviar.prop("disabled", false);
                    }
                });
        });
};
